module.exports = __webpack_public_path__ + "static/media/ico_boteria.757ca851.svg";